import { FC } from "react";
import { StyledAppLoaderLogoWrapper } from "./styled";

const AppLoader: FC = () => {
  return (
    <StyledAppLoaderLogoWrapper>
      <img src="/logo/rollin-logo.svg" alt="rollin-logo" />
    </StyledAppLoaderLogoWrapper>
  );
};

export default AppLoader;
